import { useAuthStore } from '../stores/useAuthStore.js'

interface ApiResponse<T> {
  data: T
}

interface ApiError {
  error: string
  message: string
}

export class ApiClientError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message)
    this.name = 'ApiClientError'
  }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const tokens = useAuthStore.getState().tokens
  const headers = new Headers(options.headers)

  if (tokens) {
    headers.set('access-token', tokens.accessToken)
    headers.set('client', tokens.client)
    headers.set('uid', tokens.uid)
  }

  if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json')
  }

  const response = await fetch(path, { ...options, headers })

  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as ApiError
    throw new ApiClientError(
      response.status,
      body.error ?? 'UNKNOWN',
      body.message ?? 'Erro desconhecido',
    )
  }

  const body = (await response.json()) as ApiResponse<T>
  return body.data
}
